<template>
  <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="46" cy="46" r="45" fill="#ffffff" stroke="#ffffff"/>
<path d="M64 42.5359C66.6667 44.0755 66.6667 47.9245 64 49.4641L40 63.3205C37.3333 64.8601 34 62.9356 34 59.8564L34 32.1436C34 29.0644 37.3333 27.1399 40 28.6795L64 42.5359Z" fill="#727CF5"/>
</svg>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    circle, path {

        transition: all 0.2s ease;
    }
    &:hover {
        circle {
            fill: #727CF5;
            stroke: #727CF5;
        }
        path {
            fill: #ffffff;
        } 
    }
}
</style>